import _ from 'lodash';
import createReactClass from 'create-react-class';
import Morearty from 'morearty';
import React from 'react';
import PropTypes from 'prop-types';

import ActionMixin from 'components/lib/action_mixin';
import AppFeaturesMixin from 'components/lib/app_features_mixin';
import Assignee from 'models/assignee';
import Assignment from './assignment';
import ProvidersMixin from 'components/lib/providers_mixin';
import SharedBindingsMixin from 'components/lib/shared_bindings_mixin';
import ShowReopenConversationModal from 'actions/conversation/show_reopen_conversation_modal';

const GROUP_ASSIGNEE = ':group:';
const AGENT_ASSIGNEE = ':agent:';

export const RoutingGroupOptionsPropTypes = PropTypes.arrayOf(
  PropTypes.shape({
    routingGroupId: PropTypes.string,
    label: PropTypes.string,
    sublabel: PropTypes.string,
    value: PropTypes.string,
  })
);

const AssignmentContainer = createReactClass({
  mixins: [ActionMixin, AppFeaturesMixin, Morearty.Mixin, ProvidersMixin, SharedBindingsMixin],

  propTypes: {
    assignee: PropTypes.instanceOf(Assignee),
    assignmentClassName: PropTypes.string,
    avatarProfile: PropTypes.shape({
      name: PropTypes.string,
      image: PropTypes.string,
    }),
    className: PropTypes.string,
    conversationAssignment: PropTypes.bool,
    conversationId: PropTypes.string,
    dropDown: PropTypes.bool,
    isClosedConversation: PropTypes.bool,
    isDisabled: PropTypes.bool,
    isInline: PropTypes.bool,
    label: PropTypes.string,
    onlyGroups: PropTypes.bool,
    onAssigneeChange: PropTypes.func.isRequired,
    routingGroupOptions: RoutingGroupOptionsPropTypes,
  },

  UNSAFE_componentWillMount() {
    this.observeBinding(this.getSharedBinding('agents'));
    this.observeBinding(this.getSharedBinding('routingGroups'));
    this.observeBinding(this.getSharedBinding('currentAgent'));

    this.routingGroupOptions = this.getRoutingGroupOptions();
  },

  UNSAFE_componentWillUpdate() {
    let ctx = this.getMoreartyContext();
    const p = ctx.getPreviousState();
    const c = ctx.getCurrentState();

    if ((!p && c) || c.get('agents') !== p.get('agents') || c.get('routingGroups') !== p.get('routingGroups')) {
      this.routingGroupOptions = this.getRoutingGroupOptions();
    }
  },

  focus() {
    this.assignment.focus();
  },

  onAssigneeChange(assigneeOption) {
    const assigneeAttrs = new Assignee({
      agentId: assigneeOption.agentId,
      routingGroupId: assigneeOption.routingGroupId,
    });

    return this.props.onAssigneeChange(assigneeAttrs);
  },

  getAssignedGroup() {
    const routingGroupsProvider = this.getProvider('routingGroups');
    let assignedGroupId = null;
    let assignedGroupName = null;
    if (this.props.assignee && routingGroupsProvider.findBy({ id: this.props.assignee.routingGroupId })) {
      const assignedGroup = routingGroupsProvider.findBy({ id: this.props.assignee.routingGroupId });
      assignedGroupId = GROUP_ASSIGNEE + assignedGroup.id;
      assignedGroupName = assignedGroup.name;

      if (assignedGroup.disabled) {
        assignedGroupName = `${assignedGroup.name} (Disabled)`;
      }
    }
    return { assignedGroupId, assignedGroupName };
  },

  getRoutingGroupOptions() {
    const agentsProvider = this.getProvider('agents');
    const routingGroupsProvider = this.getProvider('routingGroups');

    if (this.props.routingGroupOptions) {
      return this.props.routingGroupOptions;
    }
    return getRoutingGroupOptions({
      agentsProvider,
      isFeatureEnabled: this.isFeatureEnabled,
      routingGroupsProvider,
    });
  },

  getAssignedAgentId() {
    const agentsProvider = this.getProvider('agents');
    let assignedAgentId = null;
    let assignee = this.props.assignee;

    if (assignee && assignee.agentId && agentsProvider.findBy({ id: assignee.agentId })) {
      assignedAgentId = AGENT_ASSIGNEE + assignee.agentId;
    }
    return assignedAgentId;
  },

  render() {
    const routingGroupsProvider = this.getProvider('routingGroups');
    const agentsProvider = this.getProvider('agents');

    const { assignedGroupId, assignedGroupName } = this.getAssignedGroup();
    const assignedAgentId = this.getAssignedAgentId();

    const routingGroups = routingGroupsProvider.findAll();
    let routingGroupOptions = this.routingGroupOptions;
    let disabledInboxOptions = [];
    [routingGroupOptions, disabledInboxOptions] = _.partition(routingGroupOptions, option => !option.disabled);

    const currentAgentId = this.getSharedBinding('currentAgent').get('id');
    const allAgents = agentsProvider.findAll();
    const agentsById = _.keyBy(allAgents, 'id');

    let options = [];
    if (this.props.onlyGroups) {
      options = [
        {
          label: 'Inboxes',
          children: routingGroupOptions,
        },
        {
          label: 'hidden inboxes',
          children: disabledInboxOptions,
          hidden: true,
        },
      ];
    } else {
      let allTeammateOptions = [];
      _.forEach(_.sortBy(routingGroups, 'name'), routingGroup => {
        _.forEach(routingGroup.agentIds, agentId => {
          let agent = agentsById[agentId];
          if (!agent) {
            return;
          }
          allTeammateOptions.push(this.agentRoutingGroupOption(agent, currentAgentId, routingGroup));
        });

        // If the agent was removed from the inbox but still has conversations assigned to that agent / routing group combo,
        // we still need to be able to see it in the list of assigned agents even if it's no longer a valid selectable
        // combination.
        if (
          this.props.assignee &&
          routingGroup.id === this.props.assignee.routingGroupId &&
          this.props.assignee.agentId &&
          !_.includes(routingGroup.agentIds, this.props.assignee.agentId) &&
          agentsById[this.props.assignee.agentId]
        ) {
          allTeammateOptions.push(
            this.agentRoutingGroupOption(agentsById[this.props.assignee.agentId], currentAgentId, routingGroup)
          );
        }
      });
      allTeammateOptions = _.sortBy(allTeammateOptions, option => option.label.toLowerCase());

      let [teammateOptions, disabledTeammateOptions] = _.partition(
        allTeammateOptions,
        opt => !agentsById[opt.agentId].isDisabled()
      );

      options = [
        {
          label: 'Inboxes',
          children: routingGroupOptions,
        },
        {
          label: 'All Teammates',
          children: teammateOptions,
        },
        // Even those these aren't visible options, they must be included to display the current assignee if
        // that assignee is for some reason disabled.
        {
          label: 'hidden teammates',
          children: disabledTeammateOptions,
          hidden: true,
        },
        {
          label: 'hidden inboxes',
          children: disabledInboxOptions,
          hidden: true,
        },
      ];
    }

    return (
      <Assignment
        assignedAgentId={assignedAgentId}
        assignedGroupId={assignedGroupId}
        assignedGroupName={assignedGroupName}
        assignmentClassName={this.props.assignmentClassName}
        avatarProfile={this.props.avatarProfile}
        className={this.props.className}
        conversationAssignment={this.props.conversationAssignment}
        dropDown={this.props.dropDown}
        isClosedConversation={this.props.isClosedConversation}
        isDisabled={this.props.isDisabled}
        isInline={this.props.isInline}
        label={this.props.label}
        onAssigneeChange={this.onAssigneeChange}
        onFocus={this.showReopenConversationModal}
        options={options}
        ref={node => (this.assignment = node)}
      />
    );
  },

  agentRoutingGroupOption(agent, currentAgentId, routingGroup) {
    let routingGroupDisabled = '';
    if (routingGroup.disabled) {
      routingGroupDisabled = ` (Disabled)`;
    }
    let agentLabel = agent.name ? agent.name : agent.email;
    let currentGroupLabel =
      this.props.assignee &&
      agent.id === this.props.assignee.agentId &&
      routingGroup.id === this.props.assignee.routingGroupId
        ? ` in ${routingGroup.name}${routingGroupDisabled}`
        : '';
    return {
      agentId: agent.id,
      routingGroupId: routingGroup.id,
      label: `${agentLabel}${agent.id === currentAgentId ? ' (You)' : ''}${currentGroupLabel}`,
      sublabel: `in ${routingGroup.name}${routingGroupDisabled}`,
      value: `${GROUP_ASSIGNEE}${routingGroup.id}${AGENT_ASSIGNEE}${agent.id}`,
    };
  },

  showReopenConversationModal() {
    if (this.props.isClosedConversation) {
      this.executeAction(ShowReopenConversationModal);
    }
  },
});

export function getRoutingGroupOptions({ agentsProvider, isFeatureEnabled, routingGroupsProvider }) {
  let routingGroups = routingGroupsProvider.findAll();

  let routingGroupOptions = routingGroups.map(routingGroup => {
    let activeAgents = [];
    routingGroup.agentIds.forEach(agentId => {
      const agent = agentsProvider.findBy({ id: agentId });
      if (agent && !agent.isDisabled()) {
        activeAgents.push(agentId);
      }
    });
    const pluralize = activeAgents.length !== 1 ? 's' : '';
    return {
      disabled: routingGroup.disabled,
      routingGroupId: routingGroup.id,
      label: routingGroup.disabled ? `${routingGroup.name} (Disabled)` : routingGroup.name,
      sublabel: `${activeAgents.length} Agent${pluralize}`,
      value: GROUP_ASSIGNEE + routingGroup.id,
    };
  });
  return _.sortBy(routingGroupOptions, option => option.label.toLowerCase());
}

export default AssignmentContainer;



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/lib/assignment_container.jsx